import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { dashboardUserApi } from '~/utils/api';

export const requestSlackInvite = async () =>
  dashboardUserApi.post<RcInstanceDTO.User>('/slack-invite');
